import { createAxiosInstance } from "@/services/util";
import { Desk } from "@/swagger/models";
import { defineStore } from "pinia";

const axios = createAxiosInstance();

export const useDeskStore = defineStore({
    id: "desk",
    state: () => ({}),
    actions: {
        async patch(id: number, data: Partial<Desk>): Promise<Desk> {
            const res = await axios.put<Desk>(`/desks/${id}`, data);
            console.log(res.data);
            return res.data;
        },
    },
});
